module.exports = __webpack_public_path__ + "media/img/pages/companies/mikron-b29e402192b645eacb5aa66d8d682977.png";